import { useEffect, useState } from "react"

const useProjectDetails = projectId => {
    console.log(projectId)
    const [project, setProject] = useState([]);
    useEffect(() => {
        fetch(`https://nameless-inlet-82979.herokuapp.com/projects/${projectId}`)
            .then(res => res.json())
            .then(data => setProject(data))
    }, [projectId])

    return [project, setProject];
   
}

export default useProjectDetails;